import { __awaiter } from 'tslib';

const ENDPOINT = 'VALIDATEuploadsize';
function validateUploadSize(gateway, params, customURL = null, customHeaders = null, isKoussa = false) {
    return __awaiter(this, void 0, void 0, function* () {
        return gateway.get(validateUploadSize.endpoint, params, customURL, customHeaders, isKoussa);
    });
}
validateUploadSize.endpoint = ENDPOINT;

export { validateUploadSize as default };
//# sourceMappingURL=validateUploadSize.js.map
